export default __webpack_public_path__ + "static/media/giphy-unscreen.5f08580a.gif";